package com.wintermar.inspection.feature.util.finding_category

import androidx.compose.ui.graphics.Color

data class FindingCategoryModel(
    val color: Color = Color.Transparent,
    val label: String = "",
    val description: String = ""
)
